import { createAction } from '@ngrx/store';

import { ClientCreateParsedData, ClientPackageOption, ClientProfileAge } from '@admin/src/core/models/client-create-ui-state.interface';

export const setClientCreateUiStep = createAction('[Client Create UI] Set Step', (step: number) => ({ step }));

export const setClientCreateData = createAction('[Client Create UI] Set Data', (data: ClientCreateParsedData | null) => ({ data }));
export const setClientProfileAge = createAction('[Client Create UI] Set Client Profile Age', (age: ClientProfileAge | null) => ({ age }));

export const getClientPackagesOptions = createAction('[Client Create UI] Set Packages Options');
export const getClientPackagesOptionsSuccess = createAction('[Client Create UI] Set Packages Options Success', (packages: ClientPackageOption[]) => ({ packages }));
export const getClientPackagesOptionsFailure = createAction('[Client Create UI] Set Packages Options Failure', (error: any) => ({ error }));
